import { toast } from '@/helpers/toast/toast.helper'
import { zApiMultiService } from '@/services/api'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { clearActiveChatAction, exitGroupAction } from '../../handles'
import { exitGroup } from '../_http/groups'

export function* exitGroupSaga(action: ReturnType<typeof exitGroupAction.request>) {
  const { deleteToo, activeChat, campaign, callBack } = action.payload
  try {
    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/leave-group`
    const exitGroupResponse: AxiosResponse = yield zApiMultiService.post(url, {
      groupId: activeChat.phone
    })

    if (exitGroupResponse.data?.value) {
      yield exitGroup(activeChat.id, campaign.phoneNumber, deleteToo, activeChat.ownerId)
      callBack?.()
      toast({ type: 'success', message: `Você saiu do grupo ${activeChat.chatName}` })
      yield put(clearActiveChatAction())
      yield put(exitGroupAction.success({ chatId: activeChat.id, deleteToo }))
    } else {
      toast({ type: 'error', message: 'Não foi possível sair do grupo, tente novamente' })
      yield put(exitGroupAction.failure(null))
    }
  } catch (error) {
    toast({ type: 'error', message: 'Erro ao sair do grupo' })
    console.log({ exitGroupSaga: error })
    yield put(exitGroupAction.failure(error))
  }
}
